import localDataFunctions from "@/localDataFunctions";
import axios from 'axios';

export default {
  name: "EnquiriesTools",
  mixins: [localDataFunctions],
  data: function () {
    return {
      enqIcons: {
        customFields: {
          icon: "tune",
          label: this.$t("enquiriesAccount.CustomFields"), //Custom Fields
        },
        general: {
          icon: "account_box",
          label: this.$t("enquiriesCustomerDetails.general"), //general
        },
        details: {
          icon: "manage_accounts",
          label: this.$t("enquiriesCustomerDetails.details"), //details
        },
        applications: {
          icon: "apps",
          label: this.$t("enquiriesCustomerDetails.applications"), //applications
        },
        comments: {
          icon: "chat",
          label: this.$t("enquiriesCustomerDetails.comments"), //comments
        },
        attachments: {
          icon: "attachment",
          label: this.$t("enquiriesCustomerDetails.attachments"), //attachments
        },
        images: {
          icon: "image",
          label: this.$t("enquiriesCustomerDetails.images"), //images
        },
        detailChanges: {
          icon: "settings_applications",
          label: this.$t("enquiriesCustomerDetails.detailchanges"), //detail changes
        },
        connection: {
          label: this.$t("enquiries.connection"), //connection
          icon: "cable",
        },
        subConnections: {
          label: this.$t("enquiries.subConnections"), //sub connections
          icon: "leak_add",
        },
        debtManagement: {
          icon: "credit_card",
          label: this.$t("enquiries.debitManagement"), //debt management
        },
        deposits: {
          icon: "payments",
          label: this.$t("enquiriesCustomerDetails.deposits"), //deposits
        },
        readings: {
          icon: "speed",
          label: this.$t("enquiries.readings"), //readings
        },
        meter: {
          label: this.$t("enquiriesConnectionDetails.meter"), //meter
          icon: "gas_meter",
        },
        plots: {
          label: this.$t("enquiriesCustomerDetails.plots"), //plots
          icon: "signal_cellular_alt",
        },
        transactions: {
          icon: "credit_card",
          label: this.$t("enquiriesCustomerDetails.transactions"), //transactions
        },
        unbilledTransactions: {
          icon: "credit_card_off",
          label: this.$t("enquiries.unbilledTransactions"), //unbilled transactions
        },
        statements: {
          icon: "summarize",
          label: this.$t("enquiriesCustomerDetails.statements"), //statements
        },
        settings: {
          icon: "settings",
        },
        linkedAccounts: {
          icon: "link",
          label: this.$t("enquiriesCustomerDetails.portalaccount"), //prtal linked account
        },
        linkedProperties: {
          icon: "other_houses",
          label: this.$t("enquiriesCustomerDetails.linkedProp"), //portal represented linked properties
        },
        sms: {
          icon: "sms",
          label: this.$t("enquiriesCustomerDetails.sms"), //sms
        },
        engineering: {
          icon: "engineering",
          label: this.$t("enquiriesPropertyDetails.engineering"), //engineering
        },
        owners: {
          label: this.$t("enquiriesPropertyDetails.owners"),
          icon: "group",
        },
        discounts: {
          label: this.$t("enquiriesPropertyDetails.discounts"),
          icon: "percent",
        },
        history: { icon: "history", label: this.$t("enquiries.history") },
        consumption: { icon: "trending_up" },
        barChart: { icon: "bar_chart" },
        address: { icon: "contact_mail" },
        gpsPin: { icon: "location_on" },
        other: { icon: "" },
        property: { icon: "home" },
        log: { icon: "book" },
        operations: { icon: "replay" },
        signature: { icon: "draw" },
        pie: { icon: "pie_chart" },
        alert: { icon: "warning" },
        info: { icon: "info" },
        person: { icon: "person" },
        dots: { icon: "more_horiz" },
        account: { icon: "account_circle" },
        cases: { icon: "cases" },
        agreement: { icon: "handshake" },
        investigation: { icon: "travel_explore" },
        dottedHouse: { icon: "other_houses" },
        openLocation: { icon: 'location_on' },
        tableChart: { icon: 'table_chart' }
      },
      tabs: {},
      settings: {},

      propId: '',
      custkey: '',
      selectedTab: '',

      isStatementsExpanded: false,
      isReadingsExpanded: false,
      isApplicationsExpanded: false,
      isDmExpanded: false,
      isHistoryExpanded: false,
    };
  },
  created() {
    this.propId = this.$route.params.propertyId;
    this.custkey = this.$route.params.custkey;

    this.tabs = {
      AccountDetails: {
        label: this.$t('enquiriesAccount.AccountDetails'),
        icon: this.enqIcons.details.icon,
        show: true
      },
      CustomerAllDetails: {
        label: this.$t('enquiriesAccount.CustomerDetails'),
        icon: this.enqIcons.account.icon,
        show: true
      },
      CustomerDetails: {
        label: this.$t("enquiries.customer"),
        icon: this.enqIcons.person.icon,
        show: true
      },
      Properties: {
        label: this.$t("enquiries.properties"),
        icon: this.enqIcons.property.icon,
        show: true
      },
      Connections: {
        label: this.$t("enquiries.connection"),
        icon: this.enqIcons.connection.icon,
        show: false
      },

      Statements: {
        ...this.enqIcons.statements,
        show: true,
        expand: {
          Statements: {
            ...this.enqIcons.statements,
            show: true,
          },
          UnbilledTransactions: {
            ...this.enqIcons.unbilledTransactions,
            show: true,
          },
          Transactions: {
            ...this.enqIcons.transactions,
            show: true,
          },
        }
      },

      Readings: {
        ...this.enqIcons.readings,
        show: false,
        expand: {
          Readings: {
            ...this.enqIcons.readings,
            show: true,
          },
          Consumption: {
            label: this.$t('enquiries.consumptions'),
            icon: this.enqIcons.consumption.icon,
            show: true,
          },
          ReadingGraph: {
            label: this.$t('enquiries.readingsGraph'),
            icon: this.enqIcons.barChart.icon,
            show: true,
          },
        }
      },

      Applications: {
        ...this.enqIcons.applications,
        show: true,
        expand: {
          AccountApplications: {
            label: this.$t('enquiries.accountApplications'),
            icon: this.enqIcons.account.icon,
            show: true,
          },
          PropertiesApplications: {
            label: this.$t('enquiries.propertyApplications'),
            icon: this.enqIcons.dottedHouse.icon,
            show: true,
          },
        }
      },

      DebtManagement: {
        ...this.enqIcons.debtManagement,
        show: true,
        expand: {
          DmCases: {
            label: this.$t('enquiries.dmCases'),
            icon: this.enqIcons.cases.icon,
            show: true,
          },
          DmAgreements: {
            label: this.$t('enquiries.dmAgreements'),
            icon: this.enqIcons.agreement.icon,
            show: true,
          },
          DmInvestigations: {
            label: this.$t('enquiries.dmInvestigations'),
            icon: this.enqIcons.investigation.icon,
            show: true,
          },
          Deposits: {
            ...this.enqIcons.deposits,
            show: true,
          },
        }
      },

      History: {
        ...this.enqIcons.history,
        show: true,
        expand: {
          PropertyHistory: {
            label: this.$t('enquiries.propertyHistory'),
            icon: this.enqIcons.property.icon,
            show: true,
          },
          ConnectionHistory: {
            label: this.$t('enquiries.connectionHistory'),
            icon: this.enqIcons.connection.icon,
            show: true,
          },
        }
      },

    };

    this.getSettings();
  },
  mounted() {
    if (this.init)
      this.init();
  },
  computed: {
    selectedTabObj: function () {
      switch (this.selectedTab) {
        case 'Transactions':
          return this.tabs.Statements.expand[this.selectedTab];
        case 'UnbilledTransactions':
          return this.tabs.Statements.expand[this.selectedTab];

        case 'Consumption':
          return this.tabs.Readings.expand[this.selectedTab];
        case 'ReadingGraph':
          return this.tabs.Readings.expand[this.selectedTab];

        case 'AccountApplications':
          return this.tabs.Applications.expand[this.selectedTab];
        case 'PropertiesApplications':
          return this.tabs.Applications.expand[this.selectedTab];

        case 'DmCases':
          return this.tabs.DebtManagement.expand[this.selectedTab];
        case 'DmAgreements':
          return this.tabs.DebtManagement.expand[this.selectedTab];
        case 'DmInvestigations':
          return this.tabs.DebtManagement.expand[this.selectedTab];
        case 'Deposits':
          return this.tabs.DebtManagement.expand[this.selectedTab];

        case 'PropertyHistory':
          return this.tabs.History.expand[this.selectedTab];
        case 'ConnectionHistory':
          return this.tabs.History.expand[this.selectedTab];
        default:
          return this.tabs[this.selectedTab];
      }
    },
  },
  methods: {
    toggleMenu(saveLocation) {
      this.menuVisible = !this.menuVisible;
      this.saveToLocal(saveLocation, this.menuVisible);
    },
    toolbarAction(item) {
      console.log("toolbarAction", item);
    },
    tabSelected(id) {
      if (Array.isArray(id)) {
        let flag = false;
        id.forEach((i) => {
          if (i == this.selectedTab)
            flag = true;
        });

        return flag ? "selected-tab-icon" : "";
      }

      if (id == this.selectedTab)
        return "selected-tab-icon";
      else
        return;
    },

    openNewWindow(path) {
      window.open(window.location.origin + path);
    },
    openReadingsDetails(event) {
      let routeData = this.$router.resolve({
        name: 'readingDetails', params: {
          ConnectionId: event.data.connectionId,
          MeterId: event.data.meterId,
          ReadingNo: event.data.readingNo
        }
      });
      window.open(routeData.href, '_blank');
    },
    openMeterDetailsCustomer(event) {
      console.log("eee", event)
      return;
      let routeData = this.$router.resolve({
        name: 'customer', params: {
          //custkey: custKey,
          MeterId: event.data.meterId,
          ReadingNo: event.data.readingNo
        }
      });
      window.open(routeData.href, '_blank');
    },
    openMeterDetails(event, tab) {
      let routeData = this.$router.resolve({ name: 'meterDetails', params: { MeterId: event.data.meterId } });
      tab = tab ? '/tab/' + tab : '';
      window.open(routeData.href + tab, '_blank');
    },

    findDefaultTab(isCustomer = false) {
      let tab = this.$route.params.tabId;
      tab = tab ? tab.toLowerCase() : '';

      if (isCustomer) {
        let indx = this.CustomerData.findIndex(object => object.idx.toLowerCase() === tab);
        if (indx >= 0)
          this.selectedTab = this.CustomerData[indx].idx;
      }
      else {
        let indx = this.tabs.findIndex(object => object.id.toLowerCase() === tab);
        if (indx >= 0)
          this.selectedTab = this.tabs[indx].id;
      }      
    },
    goToDefaultTab(defaultTab) {      
      let path = this.$route.fullPath.toLowerCase();
      let tab = path.split('/')[2];

      //if (obj.toLowerCase() == 'history' || obj.toLowerCase() == 'debtManagement' ||
      //  obj.toLowerCase() == 'applications' || obj.toLowerCase() == 'readings' || obj.toLowerCase() == 'statements')
      for (const obj in this.tabs) {
        if (obj.toLowerCase() == tab) {
          this.selectedTab = obj;
        }
        else if (this.tabs[obj] && this.tabs[obj].expand) {
          for (const obj1 in this.tabs[obj].expand) {
            if (obj1.toLowerCase() == tab) {
              this.selectedTab = obj1;
            }
          }
        }
      }    
    },
    changeUrl(val) { //TBI Remove when finished
      if (!val)
        return;

      //console.log("path", this.$route)

      let fullPath = this.$route.fullPath;
      let hasDash = fullPath.substring(fullPath.length - 1, fullPath.length) == '/'

      if (!hasDash)
        fullPath = fullPath + '/';

      if (this.$route.params.tabId) {
        let urlArr = fullPath.split('/');
        urlArr[urlArr.length - 2] = encodeURIComponent(val);

        let url = urlArr.join('/');
        history.pushState({}, null, url);
      }
      else
        history.pushState({}, null, fullPath + 'tab/' + encodeURIComponent(val));        
    },
    changeUrlLink(val) {
      if (!val)
        return;

      //console.log("path", this.$route)
     
      let fullPath = this.$route.fullPath;
      let hasDash = fullPath.substring(fullPath.length - 1, fullPath.length) == '/'

      if (!hasDash)
        fullPath = fullPath + '/';

      let urlArr = fullPath.split('/');
      urlArr[2] = encodeURIComponent(val);

      let url = urlArr.join('/');
      history.pushState({}, null, url);   
    },
    goToPage(page) {
      let flag = false;
      this.pagesLoaded.forEach(p => {
        if (p == page)
          flag = true;
      })

      //we change tab
      if (flag) {
        this.selectedTab = page;
        return;
      }

      let url = `/customer/${page}/${this.custkey}/`;

      if (this.propId)
        url = url + `${this.propId}/`;

      this.$router.push(url)
    },
    getDataFailed(e) {
      if (e) {
        if (e.response && e.response.data)
          console.error(e.response.data);

        console.error(e);
      }

      this.$oldAlertMsg('Data Not Found', 4);

      if (this.loading)
        this.loading = false;

        //TBI
      //setTimeout(() => {
      //  this.$router.push('/login');
      //}, 1000);
    },

    getSettings() {
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.status == 200) {
            this.settings = response.data.value;
            if (this.settingFor && this.settingFor == 'customer') {
              if (this.settings && !this.settings.showOwnedProperties) {
                this.tabs.Connections.show = true;
                this.tabs.Readings.show = true;
              }
              else {
                this.tabs.Connections.show = false;
                this.tabs.Readings.show = false;
              }
            }
          }
        })
        .catch(e => {
          this.tabs.Connections.show = false;
          this.tabs.Readings.show = false;
        })
    },
    changeSelectedTab(idx) {
      this.selectedTab = idx;
    },

    //grid page change
    gridPageChange(pInfo, type) {
      let selectedPinfo = this[type].pageingOption;
      if (selectedPinfo.page == pInfo.pageNumber && selectedPinfo.pageSize == pInfo.pageSize)
        return;

      this[type].pageingOption.page = pInfo.pageNumber;
      this[type].pageingOption.pageSize = pInfo.pageSize;

      if (type == 'statements')
        this.getStatements(false);
      else if (type == 'statmTransactions')
        this.getStatementTransactions(false);
      else if (type == 'transactions')
        this.getTransactions(false);
      else if (type == 'unbilledTransactions')
        this.getUnbilledTransaction(false);

      else if (type == 'AccountApplications')
        this.getAccountApplications(false);
      else if (type == 'PropertiesApplications')
        this.getPropertyApplications(false);
      else if (type == 'DmCases')
        this.getDmCases(false);
      else if (type == 'DmAgreements')
        this.getDmAgreements(false);
      else if (type == 'DmInvestigations')
        this.getDmInvestigations(false);
      else if (type == 'Deposits')
        this.getDeposits(false);
      else if (type == 'PropertyHistory')
        this.getPropertyHistory(false);
      else if (type == 'ConnectionHistory')
        this.getConnectionHistory(false);
      else if (type == 'Readings')
        this.getReadings(false);
    },

    getCustomerDisplayInfo() {
      this.customerAllData = this.$store.getters.getEnqCustomerDisplayData;
      this.$forceUpdate();

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/GetCustomerDisplayInfo', parameters)
        .then(response => {
          //console.log('response', response);
          if (response.data.data.status == 0) {
            this.customerAllData = response.data.custData;
            this.$store.commit('setEnqCustomerDisplayData', this.customerAllData);
          }
          else {
            this.customerAllData = null;
          }
        })
        .catch(e => {
          this.customerAllData = null;
        })
        .finally(() => {
          this.isDetLoading = false;
        });
    },    
  },
};
